export default __webpack_public_path__ + "static/media/netatmo.a82e455a.png";